/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum SharedMediaModelStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum SharedMediaDownloadStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum SelfTapePerformerRequestStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum RequestPatchPropertyNames {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** @format int32 */
export enum ProjectStatus {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum MediaType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum MediaSource {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum MediaRequestType {
  Value0 = 0,
  Value1 = 1,
}

export interface AgentInfo {
  /** @format int32 */
  agentRef?: number;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  mobilePhone?: string | null;
  website?: string | null;
}

export interface Attachment {
  /** @format uuid */
  id?: string;
  title?: string | null;
  s3ObjectKey?: string | null;
  mimeType?: string | null;
  url?: string | null;
}

export interface AttachmentDownload {
  title?: string | null;
  s3ObjectKey?: string | null;
  s3Bucket?: string | null;
  mimeType?: string | null;
}

export interface AttachmentUploadCreated {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  mimeType: string;
  /**
   * @format int32
   * @min 1
   * @max 50000000
   */
  size: number;
  s3ObjectKey?: string | null;
  /** @format uri */
  uploadUri?: string | null;
}

export interface BreakdownRoleFilter {
  breakdown?: DocumentFilterInfo;
  roles?: DocumentFilterInfo[] | null;
}

export interface CastingDirectorDto {
  id?: string | null;
  name?: string | null;
  email?: string | null;
}

export interface CastingMedia {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  selectedThumbnail?: number;
  /** @format uuid */
  mediaInfoId?: string;
  mediaType?: MediaType;
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  durationInMs?: number;
  source?: MediaSource;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  modified?: string;
  project?: DocumentFilterInfo;
  roles?: DocumentFilterInfo[] | null;
  breakdowns?: DocumentFilterInfo[] | null;
  selfTapeRequest?: MediaDocumentFilterInfo;
  spotlightPerformers?: PerformerDocumentFilterInfo[] | null;
  performers?: PerformerDocumentFilterInfo[] | null;
  projectPerformers?: PerformerDocumentFilterInfo[] | null;
  performerRoleLinks?: PerformerRoleLink[] | null;
  notes?: string | null;
  tags?: string[] | null;
}

export interface CastingMediaFilters {
  breakdownRoles?: BreakdownRoleFilter[] | null;
  performers?: PerformerFilter[] | null;
}

export interface CastingMediaPaginatedResponse {
  /** @format int64 */
  totalResults?: number;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  results?: CastingMedia[] | null;
}

export interface CreateAttachment {
  title?: string | null;
  s3ObjectKey?: string | null;
  mimeType?: string | null;
}

export interface CreateCastingMedia {
  notes?: string | null;
  tags?: string[] | null;
  performerIds?: string[] | null;
  projectPerformers?: ProjectPerformerModel[] | null;
  breakdownIds?: string[] | null;
  roleIds?: string[] | null;
  performerRoleLinks?: PerformerRoleLink[] | null;
  /** @format uuid */
  projectId?: string;
  title?: string | null;
  mediaType: MediaType;
  /** @format uuid */
  mediaInfoId: string;
}

export interface CreatePerformerInvite {
  /** @format uuid */
  performerGuid?: string | null;
  artistRef?: string | null;
  /** @format int32 */
  submittedBySiteUserId?: number | null;
  /** @format uuid */
  submittedById?: string | null;
  /** @format int32 */
  agencyRef?: number;
}

export interface CreatePerformerSharedMedia {
  /** @format uuid */
  performerId?: string;
  castingMediaIds?: string[] | null;
  notes?: string | null;
}

export interface CreateRequest {
  /** @minLength 1 */
  title: string;
  /** @format date-time */
  expiryDate: string;
  mediaRequestType?: MediaRequestType;
  description?: string | null;
  /** @format uuid */
  breakdownId?: string;
  isAnyNumberOfVideosAllowed?: boolean;
  videosRequired?: CreateRequiredVideo[] | null;
  attachments?: CreateAttachment[] | null;
  rolesIds?: string[] | null;
}

export interface CreateRequiredVideo {
  instructions?: string | null;
}

export interface CreateSharedMedia {
  /** @format uuid */
  projectId?: string;
  /** @minLength 1 */
  name: string;
  notes?: string | null;
  /** @format date-time */
  expiryDate: string;
  performerSharedMedia?: CreatePerformerSharedMedia[] | null;
}

export interface CreateSubmission {
  /** @format uuid */
  breakdownId: string;
  /** @format uuid */
  projectId: string;
  videos?: CreateSubmissionMedia[] | null;
  comments?: string | null;
}

export interface CreateSubmissionMedia {
  /** @format uuid */
  mediaInfoId: string;
  /** @format uuid */
  requiredMediaId: string;
  /** @minLength 1 */
  title: string;
}

export interface DocumentFilterInfo {
  id?: string | null;
  name?: string | null;
}

export interface MediaDocumentFilterInfo {
  id?: string | null;
  name?: string | null;
  /** @format int32 */
  mediaRequestType?: number;
}

export interface Notification {
  id?: string | null;
  /** @format date-time */
  notified?: string;
  /** @format date-time */
  acknowledged?: string | null;
  project?: DocumentFilterInfo;
  breakdown?: DocumentFilterInfo;
  roles?: DocumentFilterInfo[] | null;
  performer?: PerformerDocumentFilterInfo[] | null;
  castingDirector?: DocumentFilterInfo;
  notificationData?: any | null;
}

export interface NotificationFilters {
  breakdownRoles?: BreakdownRoleFilter[] | null;
  performers?: PerformerFilter[] | null;
}

export interface NotificationPaginatedResponse {
  /** @format int64 */
  totalResults?: number;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  results?: Notification[] | null;
}

export interface NotificationStatus {
  /** @format uuid */
  id?: string;
  acknowledged?: boolean;
}

export interface PerformerDocumentFilterInfo {
  id?: string | null;
  name?: string | null;
  artistRef?: string | null;
  profileUri?: string | null;
  mainPhotoUri?: string | null;
}

export interface PerformerFilter {
  id?: string | null;
  name?: string | null;
  isProjectPerformer?: boolean;
}

export interface PerformerInfo {
  /** @format uuid */
  id?: string;
  artistRef?: string | null;
  forename?: string | null;
  surname?: string | null;
  /** @format int32 */
  publicationCode?: number;
  email?: string | null;
  mainAgent?: AgentInfo;
}

export interface PerformerInvite {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  requestId?: string;
  /** @format uuid */
  performerId?: string;
  /** @format date-time */
  requestedAt?: string;
  status?: string | null;
  performerReplyComments?: string | null;
  /** @format date-time */
  performerReplyTimestamp?: string | null;
  /** @format int32 */
  agencyRef?: number;
  agencyName?: string | null;
  agencyEmail?: string | null;
  info?: PerformerInfo;
  showPerformerEmail?: boolean;
}

export interface PerformerInvitePaginatedResponse {
  /** @format int64 */
  totalResults?: number;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  results?: PerformerInvite[] | null;
}

export interface PerformerReply {
  isAccepted?: boolean | null;
  comments?: string | null;
}

export interface PerformerRequest {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  requestId?: string;
  /** @format uuid */
  performerId?: string;
  /** @format uuid */
  submittedBy?: string;
  /** @format date-time */
  requestedAt?: string;
  status?: SelfTapePerformerRequestStatus;
  performerReplyComments?: string | null;
  /** @format date-time */
  performerReplyTimestamp?: string | null;
  performerReplyBy?: string | null;
  requestToClientSentBy?: string | null;
  requestToClientComments?: string | null;
  forwardedToPerformer?: boolean;
  /** @format date-time */
  forwardedToPerformerTimestamp?: string | null;
  forwardedToTagmin?: boolean;
  /** @format date-time */
  forwardedToTagminTimestamp?: string | null;
  requestToTagminSentBy?: string | null;
}

export interface PerformerRequestCreationError {
  /** @format uuid */
  performerId?: string | null;
  error?: string | null;
}

export interface PerformerRequestsCreated {
  requestsCreated?: PerformerRequest[] | null;
  errors?: PerformerRequestCreationError[] | null;
}

export interface PerformerRoleLink {
  /** @format uuid */
  performerId?: string;
  /** @format uuid */
  breakdownId?: string | null;
  /** @format uuid */
  roleId?: string | null;
}

export interface PerformerSharedMediaItemModel {
  /** @format uuid */
  mediaId?: string;
  /** @format int32 */
  selectedThumbnail?: number;
  /** @format uuid */
  mediaInfoId?: string;
  mediaType?: string | null;
  title?: string | null;
  source?: string | null;
  roles?: SharedMediaRoleModel[] | null;
}

export interface PerformerSharedMediaModel {
  /** @format uuid */
  performerId?: string;
  name?: string | null;
  /** @format uuid */
  profileId?: string;
  profileUri?: string | null;
  artistRef?: string | null;
  viewPin?: string | null;
  mainPhotoFileName?: string | null;
  mainPhotoUri?: string | null;
  notes?: string | null;
  isProjectPerformer?: boolean;
  performerSharedMediaItems?: PerformerSharedMediaItemModel[] | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProjectPerformerModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
}

export interface Request {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  performerRequestId?: string;
  /** @format uuid */
  breakdownId?: string;
  /** @format uuid */
  projectId?: string;
  projectStatus?: ProjectStatus;
  title?: string | null;
  /** @format date-time */
  expiryDate?: string;
  /** @format date-time */
  originalExpiryDate?: string;
  description?: string | null;
  videosRequired?: RequiredVideo[] | null;
  rolesIds?: string[] | null;
  attachments?: Attachment[] | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  modifiedAt?: string | null;
  /** @format uuid */
  modifiedBy?: string | null;
  anyAmount?: boolean;
  /** @format int32 */
  mediaRequestType?: number;
}

export interface RequestPropertyPatch {
  path?: string | null;
  propertyName?: RequestPatchPropertyNames;
  value?: any | null;
  valueString?: string | null;
  op?: string | null;
}

export interface RequestSearchResult {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  performerRequestId?: string;
  /** @format uuid */
  breakdownId?: string;
  /** @format uuid */
  projectId?: string;
  projectStatus?: ProjectStatus;
  title?: string | null;
  /** @format date-time */
  expiryDate?: string;
  /** @format date-time */
  originalExpiryDate?: string;
  description?: string | null;
  videosRequired?: RequiredVideo[] | null;
  rolesIds?: string[] | null;
  attachments?: Attachment[] | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  modifiedAt?: string | null;
  /** @format uuid */
  modifiedBy?: string | null;
  anyAmount?: boolean;
  /** @format int32 */
  mediaRequestType?: number;
  /** @format int32 */
  inviteCount?: number;
  /** @format int32 */
  pendingCount?: number;
  /** @format int32 */
  acceptedCount?: number;
  /** @format int32 */
  declinedCount?: number;
  /** @format int32 */
  receivedCount?: number;
}

export interface RequestSearchResultPaginatedResponse {
  /** @format int64 */
  totalResults?: number;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  results?: RequestSearchResult[] | null;
}

export interface RequiredVideo {
  /** @format uuid */
  id?: string;
  instructions?: string | null;
}

export interface RoleModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
}

export interface SelfTapeRequestAttachmentPresignedUrl {
  s3ObjectKey?: string | null;
  s3PresignedUrl?: string | null;
}

export interface SendToClientRequest {
  message?: string | null;
}

export interface SendToTagminRequest {
  sentBy?: string | null;
}

export interface SharedMediaDownloadResponse {
  /** @format uuid */
  id?: string;
  status?: SharedMediaDownloadStatus;
  presignedDownloadUri?: string | null;
}

export interface SharedMediaListModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  expiryDate?: string;
  status?: SharedMediaModelStatus;
}

export interface SharedMediaModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  projectId?: string;
  name?: string | null;
  notes?: string | null;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  expiryDate?: string;
  /** @format date-time */
  dateModified?: string | null;
  status?: SharedMediaModelStatus;
  performersSharedMedia?: PerformerSharedMediaModel[] | null;
}

export interface SharedMediaPaginatedResponse {
  /** @format int64 */
  totalResults?: number;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  results?: SharedMediaListModel[] | null;
}

export interface SharedMediaRoleModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
}

export interface Submission {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  performerRequestId?: string;
  /** @format uuid */
  requestId?: string;
  /** @format uuid */
  performerId?: string;
  /** @format uuid */
  breakdownId?: string;
  /** @format uuid */
  projectId?: string;
  videos?: SubmissionMedia[] | null;
  /** @format date-time */
  submissionDate?: string;
  submissionBy?: string | null;
  /** @format int32 */
  agencyId?: number;
  isPublished?: boolean;
  comments?: string | null;
  performerReplyComments?: string | null;
  /** @format date-time */
  performerReplyTimestamp?: string | null;
  performerReplyBy?: string | null;
  status?: SelfTapePerformerRequestStatus;
}

export interface SubmissionMedia {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  mediaInfoId?: string;
  /** @format uuid */
  requiredMediaId?: string;
  /** @format uuid */
  projectMediaId?: string | null;
  title?: string | null;
}

export interface SubmissionRequest {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  performerRequestId?: string;
  /** @format uuid */
  breakdownId?: string;
  /** @format uuid */
  projectId?: string;
  projectStatus?: ProjectStatus;
  title?: string | null;
  /** @format date-time */
  expiryDate?: string;
  /** @format date-time */
  originalExpiryDate?: string;
  description?: string | null;
  videosRequired?: RequiredVideo[] | null;
  rolesIds?: string[] | null;
  attachments?: Attachment[] | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  modifiedAt?: string | null;
  /** @format uuid */
  modifiedBy?: string | null;
  /** @format int32 */
  mediaRequestType?: number;
  submissionMedia?: SubmissionMedia[] | null;
  /** @format date-time */
  submissionDate?: string | null;
  submissionBy?: string | null;
  breakdownTitle?: string | null;
  roles?: RoleModel[] | null;
  isPublished?: boolean;
  castingDirector?: CastingDirectorDto;
  performer?: PerformerDocumentFilterInfo;
  anyAmount?: boolean;
  performerReplyComments?: string | null;
  /** @format date-time */
  performerReplyTimestamp?: string | null;
  performerReplyBy?: string | null;
  status?: SelfTapePerformerRequestStatus;
  suggestedBy?: string | null;
  /** @format int32 */
  agencyId?: number;
  isTagminUser?: boolean | null;
  isTagTapesUser?: boolean | null;
  requestToClientSentBy?: string | null;
  requestToClientComments?: string | null;
  forwardedToPerformer?: boolean;
  /** @format date-time */
  forwardedToPerformerTimestamp?: string | null;
  forwardedToTagmin?: boolean;
  /** @format date-time */
  forwardedToTagminTimestamp?: string | null;
  requestToTagminSentBy?: string | null;
}

export interface UpdateCastingMedia {
  notes?: string | null;
  tags?: string[] | null;
  performerIds?: string[] | null;
  projectPerformers?: ProjectPerformerModel[] | null;
  breakdownIds?: string[] | null;
  roleIds?: string[] | null;
  performerRoleLinks?: PerformerRoleLink[] | null;
  /** @format int32 */
  selectedThumbnail?: number;
}

export interface UpdateRequestExpiryDate {
  /** @format date-time */
  expiryDate: string;
}

export interface UpdateSharedMedia {
  /** @minLength 1 */
  name: string;
  notes?: string | null;
  /** @format date-time */
  expiryDate: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Spotlight Self Tapes API
 * @version v1
 * @contact Ben Shearer
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  castingmedia = {
    /**
     * No description
     *
     * @tags CastingMedia
     * @name Get
     * @request GET:/castingmedia
     * @secure
     */
    get: <TResponse = CastingMediaPaginatedResponse, TError = any>(
      query?: {
        /** @format int32 */
        PageIndex?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format uuid */
        ProjectId?: string;
        BreakdownIds?: string[];
        RoleIds?: string[];
        /** @format date-time */
        DateSentFrom?: string;
        /** @format date-time */
        DateSentTo?: string;
        PerformerIds?: string[];
        SelfTapeRequestIds?: string[];
        PerformerName?: string[];
        MediaRequestType?: MediaRequestType[];
        MediaType?: MediaType[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/castingmedia`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CastingMedia
     * @name CreateCastingMediaItem
     * @request POST:/castingmedia
     * @secure
     */
    createCastingMediaItem: <TResponse = string, TError = any>(
      data: CreateCastingMedia,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/castingmedia`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CastingMedia
     * @name UpdateCastingMedia
     * @request PUT:/castingmedia/{id}
     * @secure
     */
    updateCastingMedia: <TResponse = unknown, TError = any>(
      id: string,
      data: UpdateCastingMedia,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/castingmedia/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CastingMedia
     * @name GetById
     * @request GET:/castingmedia/{id}
     * @secure
     */
    getById: <TResponse = CastingMedia, TError = any>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/castingmedia/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CastingMedia
     * @name Delete
     * @request DELETE:/castingmedia/{id}
     * @secure
     */
    delete: <TResponse = unknown, TError = any>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/castingmedia/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CastingMedia
     * @name SetMediaItemTags
     * @request PUT:/castingmedia/{id}/tags
     * @secure
     */
    setMediaItemTags: <TResponse = unknown, TError = any>(
      id: string,
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/castingmedia/${id}/tags`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CastingMedia
     * @name GetFilters
     * @request GET:/castingmedia/filters/{projectId}
     * @secure
     */
    getFilters: <TResponse = CastingMediaFilters, TError = any>(
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/castingmedia/filters/${projectId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CastingMedia
     * @name GetProjectPerformers
     * @request GET:/castingmedia/filters/{projectId}/projectperformers
     * @secure
     */
    getProjectPerformers: <TResponse = CastingMediaFilters, TError = any>(
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/castingmedia/filters/${projectId}/projectperformers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags Notification
     * @name SearchNotifications
     * @request GET:/notification
     * @secure
     */
    searchNotifications: <
      TResponse = NotificationPaginatedResponse,
      TError = any,
    >(
      query?: {
        /** @format int32 */
        PageIndex?: number;
        /** @format int32 */
        PageSize?: number;
        BreakdownIds?: string[];
        RoleIds?: string[];
        /** @format date-time */
        DateSentFrom?: string;
        /** @format date-time */
        DateSentTo?: string;
        PerformerIds?: string[];
        CastingDirectorIds?: string[];
        SearchText?: string;
        Acknowledged?: boolean;
        MediaRequestType?: MediaRequestType[];
        /** Notified, CastingDirector */
        SortBy?: string;
        Descending?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/notification`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name Count
     * @request GET:/notification/count
     * @secure
     */
    count: <TResponse = NotificationPaginatedResponse, TError = any>(
      query?: {
        acknowledged?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/notification/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name GetFilters
     * @request GET:/notification/filters
     * @secure
     */
    getFilters: <TResponse = NotificationFilters, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/notification/filters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name UpdateStatus
     * @request POST:/notification/status
     * @secure
     */
    updateStatus: <TResponse = unknown, TError = any>(
      data: NotificationStatus[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/notification/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name UpdatePerformerReply
     * @request POST:/notification/{performerRequestId}/reply
     * @secure
     */
    updatePerformerReply: <TResponse = unknown, TError = any>(
      performerRequestId: string,
      data: PerformerReply,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/notification/${performerRequestId}/reply`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name GetAllActiveRequestsForExternalAgency
     * @request GET:/notification/externalAgent/{externalId}
     * @secure
     */
    getAllActiveRequestsForExternalAgency: <
      TResponse = Request,
      TError = ProblemDetails,
    >(
      externalId: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/notification/externalAgent/${externalId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  selftaperequest = {
    /**
     * No description
     *
     * @tags Request
     * @name GetRequestById
     * @request GET:/selftaperequest/{requestId}
     * @secure
     */
    getRequestById: <TResponse = Request, TError = ProblemDetails>(
      requestId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/${requestId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name DeleteRequestById
     * @request DELETE:/selftaperequest/{requestId}
     * @secure
     */
    deleteRequestById: <TResponse = Request, TError = ProblemDetails>(
      requestId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/${requestId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name UpdateRequest
     * @request PATCH:/selftaperequest/{requestId}
     * @secure
     */
    updateRequest: <TResponse = Request, TError = ProblemDetails>(
      requestId: string,
      data: RequestPropertyPatch[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/${requestId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name SearchRequests
     * @request GET:/selftaperequest
     * @secure
     */
    searchRequests: <
      TResponse = RequestSearchResultPaginatedResponse,
      TError = any,
    >(
      query?: {
        /** @format uuid */
        BreakDownId?: string;
        /** @format uuid */
        ProjectId?: string;
        Title?: string;
        /** @format int32 */
        PageIndex?: number;
        /** @format int32 */
        PageSize?: number;
        /** Title, Created, Expires */
        SortBy?: string;
        Descending?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name CreateRequest
     * @request POST:/selftaperequest
     * @secure
     */
    createRequest: <TResponse = Request, TError = ProblemDetails>(
      data: CreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name GetAttachmentUpload
     * @request GET:/selftaperequest/attachment/upload
     * @secure
     */
    getAttachmentUpload: <
      TResponse = AttachmentUploadCreated,
      TError = ProblemDetails,
    >(
      query: {
        Name: string;
        MimeType: string;
        /**
         * @format int32
         * @min 1
         * @max 50000000
         */
        Size: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/attachment/upload`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name GetAttachmentDownload
     * @request GET:/selftaperequest/attachment/download
     * @secure
     */
    getAttachmentDownload: <
      TResponse = SelfTapeRequestAttachmentPresignedUrl[],
      TError = ProblemDetails,
    >(
      query?: {
        attachments?: AttachmentDownload[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/attachment/download`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name ExtendExpiryDate
     * @request PUT:/selftaperequest/{requestId}/extend-expiry
     * @secure
     */
    extendExpiryDate: <TResponse = Request, TError = ProblemDetails>(
      requestId: string,
      data: UpdateRequestExpiryDate,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/${requestId}/extend-expiry`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name CreateRequestsForPerformers
     * @request POST:/selftaperequest/{requestId}/invite
     * @secure
     */
    createRequestsForPerformers: <
      TResponse = PerformerRequestsCreated,
      TError = any,
    >(
      requestId: string,
      data: CreatePerformerInvite[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/${requestId}/invite`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name GetInvitedPerformers
     * @request GET:/selftaperequest/{requestId}/invite
     * @secure
     */
    getInvitedPerformers: <
      TResponse = PerformerInvitePaginatedResponse,
      TError = any,
    >(
      requestId: string,
      query?: {
        SortField?: string;
        Descending?: boolean;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        PageIndex?: number;
        /** @format uuid */
        PerformerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/${requestId}/invite`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name SendToClient
     * @request POST:/selftaperequest/{requestId}/sendtoclient
     * @secure
     */
    sendToClient: <TResponse = Request, TError = ProblemDetails>(
      requestId: string,
      data: SendToClientRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/${requestId}/sendtoclient`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request
     * @name SendToTagmin
     * @request POST:/selftaperequest/{requestId}/sendtotagmin
     * @secure
     */
    sendToTagmin: <TResponse = Request, TError = ProblemDetails>(
      requestId: string,
      data: SendToTagminRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/selftaperequest/${requestId}/sendtotagmin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sharedmedia = {
    /**
     * No description
     *
     * @tags SharedMedia
     * @name GetById
     * @request GET:/sharedmedia/{id}
     * @secure
     */
    getById: <TResponse = SharedMediaModel, TError = ProblemDetails>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name Delete
     * @request DELETE:/sharedmedia/{id}
     * @secure
     */
    delete: <TResponse = unknown, TError = ProblemDetails>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name Update
     * @request PUT:/sharedmedia/{id}
     * @secure
     */
    update: <TResponse = unknown, TError = ProblemDetails>(
      id: string,
      data: UpdateSharedMedia,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name GetByIdPublic
     * @request GET:/sharedmedia/{id}/public
     * @secure
     */
    getByIdPublic: <TResponse = SharedMediaModel, TError = ProblemDetails>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia/${id}/public`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name DownloadAllByIdPublic
     * @request POST:/sharedmedia/{id}/public/download
     * @secure
     */
    downloadAllByIdPublic: <TResponse = string, TError = ProblemDetails>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia/${id}/public/download`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name DownloadAllByIdPublicPoll
     * @request GET:/sharedmedia/{id}/public/download/poll
     * @secure
     */
    downloadAllByIdPublicPoll: <
      TResponse = SharedMediaDownloadResponse,
      TError = ProblemDetails,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia/${id}/public/download/poll`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name Get
     * @request GET:/sharedmedia
     * @secure
     */
    get: <TResponse = SharedMediaPaginatedResponse, TError = any>(
      query?: {
        /** @format uuid */
        ProjectId?: string;
        NameFilter?: string;
        Statuses?: SharedMediaModelStatus[];
        /** @format int32 */
        PageIndex?: number;
        /** @format int32 */
        PageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name Create
     * @request POST:/sharedmedia
     * @secure
     */
    create: <TResponse = string, TError = ProblemDetails>(
      data: CreateSharedMedia,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name Activate
     * @request POST:/sharedmedia/{id}/activate
     * @secure
     */
    activate: <TResponse = string, TError = ProblemDetails>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia/${id}/activate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedMedia
     * @name Deactivate
     * @request POST:/sharedmedia/{id}/deactivate
     * @secure
     */
    deactivate: <TResponse = string, TError = ProblemDetails>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/sharedmedia/${id}/deactivate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  submission = {
    /**
     * No description
     *
     * @tags Submission
     * @name GetBySelfTapePerformerRequestId
     * @request GET:/submission/performerrequest/{id}
     * @secure
     */
    getBySelfTapePerformerRequestId: <
      TResponse = SubmissionRequest,
      TError = ProblemDetails,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/submission/performerrequest/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Submission
     * @name CreateSubmission
     * @request POST:/submission/performerrequest/{id}
     * @secure
     */
    createSubmission: <TResponse = Submission, TError = ProblemDetails>(
      id: string,
      data: CreateSubmission,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/submission/performerrequest/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Submission
     * @name PublishSubmission
     * @request POST:/submission/performerrequest/{id}/{submissionId}/publish
     * @secure
     */
    publishSubmission: <TResponse = Submission, TError = ProblemDetails>(
      id: string,
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/submission/performerrequest/${id}/${submissionId}/publish`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
